import {h, Component, Fragment} from 'preact';
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Ticket from "../utils/ticket-logic.jsx"

import * as P from "../desktop-templates/prematch-single-event.jsx";
import * as I from "../utils/icons"

import {CollapsibleMarket as MobileCollapsibleMarket, PrematchEventPage} from "../mobile-pages/prematch-event.jsx";
import {TeamIcon} from "./live-event";

export default class PrematchEvent extends PrematchEventPage {
	render() {
		const {sport, category, tournament, event, odds} = this.state;
		
		if (event == null)
			return null;
		
		return <div>
		  <P.TitleHeader>
			<P.BackButton onClick={() => {window.history.back()}}><I.BackIconLarge class="h-4 fill-current" /></P.BackButton>
			<P.ThreeDots />
			<P.SportName>{sport.name}</P.SportName>
			<P.TournamentName>
				{category.name} - {tournament.name} / <P.MatchNameBreadcrumb>{event.home} vs. {event.away}</P.MatchNameBreadcrumb>
			</P.TournamentName>
		  </P.TitleHeader>
	
		  <P.PrematchEventNameRow>
			<P.InfoBox>
			  <P.EventBaseInfo>
				<P.TournamentBaseInfo>{category.name} - {tournament.name}</P.TournamentBaseInfo>
				  {/*<P.EventFullName>{event.home} - {event.away}</P.EventFullName>*/}
				  <div class="flex flex-row items-center justify-center font-bold pb-1">
					<div class="w-1/2 flex items-center justify-end gap-2">
						<span class="flex-shrink-0">
							<TeamIcon team={({id: '/team/0/'+ event.teamscode.home, name: event.home})} />
						</span>
						<div class="text-base">
							<span>{event.home}</span>
						</div>
					</div>
					<div class="flex-shrink-0 w-32 text-2xl tracking-wider section-highlight-color text-center">
						vs
					</div>
					<div class="w-1/2 flex items-center justify-start gap-2">
						<div class="text-base">
							<span>{event.away}</span>
						</div>
						<span class="flex-shrink-0">
							<TeamIcon team={({id: '/team/0/'+ event.teamscode.away, name: event.away})} />
						</span>
					</div>
				</div>
			  </P.EventBaseInfo>
				{/*<P.EventRapidButtons>
				<P.EventRapidButtonLeft />
				<P.EventRapidButtonRight />
			  </P.EventRapidButtons>*/}
			</P.InfoBox>
		  </P.PrematchEventNameRow>
	
		  <P.ScrollableTabsRail>
			<P.ScrollableTabsContent>
				{this.canBetbuilder() && <P.TabButton active={this.isCurrentTab({id: 'betbuilder'})} onClick={() => this.selectTab({id: 'betbuilder'})}>
					<Trans>Betbuilder</Trans>
				</P.TabButton>}
				{(event.categories || [{id: -1, name: 'All'}]).map(tab => 
					<P.TabButton active={this.isCurrentTab(tab)} onClick={() => this.selectTab(tab)}>
						{tab.name}
					</P.TabButton>
				)}
			</P.ScrollableTabsContent>
		  </P.ScrollableTabsRail>
	
			{!this.isBetbuilder() 
				? <ColumnsMarketDivision 
					  key={this.state.currentTab} 
					  columns={2} 
					  odds={odds.filter(marketGroup => marketGroup.sub[0].categories.includes(this.state.currentTab))}
					  rowComponent={CollapsibleMarket} />
				: <ColumnsMarketDivision 
					  key={this.state.currentTab} 
					  columns={2} 
					  odds={this.getBetbuilderOdds()}
					  rowComponent={BetbuilderMarket}
					  betbuilder={this.betbuilder} />}
		</div>
	}
}

export function ColumnsMarketDivision({odds, columns, rowComponent, betbuilder}) {
	const CollapsibleMarket = rowComponent;
	const partitions = new Array(columns).fill(null).map(() => []); // Serve il "map" altrimenti mette a tutti lo stesso array
	for (let idx in odds) {
		partitions[idx % columns].push(odds[idx]);
	}
	return <div class="gap-3 w-full xl:grid xl:auto-cols-fr xl:grid-flow-col">
		{partitions.map(column => <div class="min-w-0 w-full">
			{column.map((marketGroup, idx) => 
				<CollapsibleMarket 
					key={marketGroup.name} 
					marketGroup={marketGroup} 
					open={idx == 0 || (idx < 7 && marketGroup.sub.length == 1 && Object.keys(marketGroup.sub[0].sub).length <= 3)}
					betbuilder={betbuilder} />
			)}
		</div>)}
	</div>;
}

export class CollapsibleMarket extends MobileCollapsibleMarket {
	render({open, marketGroup}) {
		return <P.MarketsContainer>
		  <P.MarketHeadRow active={this.state.open} onClick={() => this.setState({open: !this.state.open, wasOpen: true})}>
			<P.MarketCollapseButton active={this.state.open}>
				<I.UpArrowIcon class={"h-4 transition-transform "+(this.state.open ? '' : 'rotate-180')} />
			</P.MarketCollapseButton>
			<P.MarketName>{marketGroup.name}</P.MarketName>
		  </P.MarketHeadRow>

		  {this.state.wasOpen && <P.OutcomesContainer open={this.state.open}>
			{marketGroup.sub.map(market => <P.OutcomesContainerRow cols={Object.keys(market.sub).length}>
				{Object.values(market.sub).map(outcome => (
					<P.OutcomeButton
						   selected={Ticket.hasPrematchOdds(outcome.id)}
						   onClick={() => Ticket.togglePrematchOdds(outcome.id)}>
					  <P.OutcomeName>{outcome.name}</P.OutcomeName>
					  <P.OutcomeValue selected={Ticket.hasPrematchOdds(outcome.id)} value={outcome.value} />
					</P.OutcomeButton>
				))}
			</P.OutcomesContainerRow>)}
		  </P.OutcomesContainer>}
		</P.MarketsContainer>;
	}
}

export class BetbuilderMarket extends MobileCollapsibleMarket {
	render({open, marketGroup, betbuilder}) {
		return <P.MarketsContainer>
		  <P.MarketHeadRow active={this.state.open} onClick={() => this.setState({open: !this.state.open, wasOpen: true})}>
			<P.MarketCollapseButton active={this.state.open}>
				<I.UpArrowIcon class={"h-4 transition-transform "+(this.state.open ? '' : 'rotate-180')} />
			</P.MarketCollapseButton>
			<P.MarketName>{marketGroup.name}</P.MarketName>
		  </P.MarketHeadRow>

		  {this.state.wasOpen && <P.OutcomesContainer open={this.state.open}>
			{marketGroup.sub.map(market => <P.OutcomesContainerRow cols={Object.keys(market.sub).length}>
				{Object.values(market.sub).map(outcome => (
					<P.OutcomeBuilderButton
						   selected={betbuilder.isOutcomeSelected(outcome)}
						   disabled={betbuilder.isOutcomeDisabled(outcome)}
						   onClick={() => betbuilder.toggleOdd(outcome).then(e => betbuilder.addBetbuilderOdd())}>
					  <P.OutcomeName>{outcome.name}</P.OutcomeName>
					  <div></div>
					</P.OutcomeBuilderButton>
				))}
			</P.OutcomesContainerRow>)}
		  </P.OutcomesContainer>}
		</P.MarketsContainer>;
	}
}

